import React from 'react';
import integration from '@assets/LandingPage/Integrations.png';
import './Integrations.css';

export default function IntegrationHero() {
  return (
   <div className="integration-hero-container">
      {/* Grid overlay */}
      <div className="integration-hero-grid-overlay">
        <div className="integration-hero-grid-pattern"></div>
      </div>

      <div className="integration-hero-content">
        {/* ───── LEFT ───── */}
        <div className="integration-hero-left-section">
          <h1 className="integration-hero-heading">
            Seamless Integrations for a Connected Learning Ecosystem
          </h1>

          <p className="integration-hero-description">
            Connect MILE LMS with your everyday tools — from Slack and Microsoft
            Teams to Workday and Salesforce. Automate workflows, sync data, and
            empower your organization with one unified learning experience.
          </p>

          <button className="integration-hero-button">
            Explore Integrations
          </button>
        </div>

        {/* ───── RIGHT ───── */}
        <div className="integration-hero-right-section">
          {/* Tilted background square (behind the card) */}
          <div className="integration-hero-tilted-square"></div>

          {/* White card with image */}
          <div className="integration-hero-image-card">
            <div className="integration-hero-image-placeholder">
              <img
                src={integration}
                alt="Integration Dashboard"
                className="integration-hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}